import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ExoDialog from '../exo/ExoDialog';
import SingleFileUpload from '../upload/SingleFileUpload';

/**
 * Standalone viewer for XRechnung / ZUGFeRD files.
 * Purely client-side: the dropped file is visualized locally, nothing is uploaded.
 */
const XRechnungViewerDialog = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <ExoDialog open={open} onClose={onClose}>
      <Box className="flex flex-col gap-2 w-full h-full">
        <Typography variant="h3">{t('View XRechnung')}</Typography>
        <Typography variant="body2" className="opacity-70">
          {t(
            'Drop an XRechnung XML or a ZUGFeRD PDF to visualize it. The file stays on your device and is not uploaded.',
          )}
        </Typography>
        <Box className="flex-1 min-h-0 w-full">
          {open && (
            <SingleFileUpload
              label={t('Drop your XRechnung or ZUGFeRD file here')}
            />
          )}
        </Box>
      </Box>
    </ExoDialog>
  );
};

export default XRechnungViewerDialog;
